import React from "react";
import Container from "./Container";
import Heading from "./Heading";

const PreviousEditions = () => {
  return (
    <>
      <section className="py-10">
        <Container>
          <Heading title={"Previous Editions"} />
        </Container>
      </section>
    </>
  );
};

export default PreviousEditions;
